import { render, staticRenderFns } from "./DashboardReceipt.vue?vue&type=template&id=7a90e4e1&scoped=true"
import script from "./DashboardReceipt.vue?vue&type=script&lang=js"
export * from "./DashboardReceipt.vue?vue&type=script&lang=js"
import style0 from "./DashboardReceipt.vue?vue&type=style&index=0&id=7a90e4e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a90e4e1",
  null
  
)

export default component.exports